<template>
    <div class="main">
      <tab title="加油记录" right-text="返回顶部" :fixed = true></tab>
      <div v-if="list.length>0" class="record_list" style="padding-top: 10px;">
        <div
          class="record_oli"
          v-for="item in list"
          v-bind:key="item.id"
          @click="toDetail(item)"
        >
          <div class="record_oli_left">
            <img
              :src="item.logo ? item.logo : '../../static/img/topup.png'"
              alt=""
            />
          </div>
          <div class="record_oli_right">
            <div class="right_title">
              {{ item.carLimit }}
            </div>
            <div class="right_title">
              {{ item.stationName }}
            </div>
            <div class="right_line">
              <div class="qm">加油量：{{ item.num }}L</div>
              <div class="price">结算金额：{{ item.realAmount }}元</div>
            </div>
            <div class="right_line">
            <div class="qm">交易时间：{{ item.completeTime }}</div>
            <!-- <div class="qm">油品类型：{{ item.qualityModel }}</div> -->
            <!-- <div class="price">结算价：{{ item.salePrice }}元/升</div> -->
          </div>
          </div>
        </div>
      </div>
      <div class="none" v-else>
        <img src="../../static/img/wujilu_img.png" alt="">
            暂无加油记录
      </div>
      <scroller :onBottom="loadmore"></scroller>
    </div>
  </template>
  
  <script>
  import tab from "@/components/NavBar";
  import scroller from "@/components/scroller";
  import Vue from "vue";
  import { Toast } from "vant";
  import { Popup } from "vant";
  import { DatetimePicker } from "vant";
  
  Vue.use(DatetimePicker);
  
  Vue.use(Popup);
  
  Vue.use(Toast);
  
  export default {
    name: "margin",
    data() {
      return {
        list: [],
        page: 1,
        pageSize: 0,
        flag: true,
        show: false,
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
        time: "",
        popupClass: "popupClass",
        sumTradeAmount: "",
        cardId:''
      };
    },
    components: {
      tab,
      scroller,
    },
    mounted() {
      var height = (document.body.clientHeight - 46) / 80;
      this.pageSize = Math.ceil(height);
      if(sessionStorage.getItem('cardId')&&sessionStorage.getItem('cardId')!=null){
        this.cardId = sessionStorage.getItem('cardId')
        // sessionStorage.setItem('cardId',null)
      }
      if(this.$route.params.item){
        console.log(this.$route.params.item.id)
        this.cardId = this.$route.params.item.id
        sessionStorage.setItem('cardId',this.cardId)
      }
      
      
      this.confirm(this.currentDate);
    },
    watch: {},
    methods: {
      cancel() {
        this.show = false;
      },
      confirm(val) {
        let year = val.getFullYear();
        let month = val.getMonth() + 1;
        let day = val.getDate();
        let hour = val.getHours();
        let minute = val.getMinutes();
        if (month >= 1 && month <= 9) {
          month = `0${month}`;
        }
        if (day >= 1 && day <= 9) {
          day = `0${day}`;
        }
        if (hour >= 0 && hour <= 9) {
          hour = `0${hour}`;
        }
        if (minute >= 0 && minute <= 9) {
          minute = `0${minute}`;
        }
        this.time = `${year}-${month}`;
        this.show = false;
        this.getOrderList();
        return `${year}-${month}`;
      },
      formatter(type, val) {
        if (type === "year") {
          return `${val}年`;
        } else if (type === "month") {
          return `${val}月`;
        }
        return val;
      },
      toDetail(item) {
        this.$router.push({
          name: "ComeOn_record_detail",
          params: { item: item },
        });
      },
      getOrderList() {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        var data = {
          token: this.$storage.get("token"),
          page: this.page,
          pageSize: this.pageSize,
          startTime: '',
          endTime: '',
          cardId:this.cardId
        };
        this.$api.post("orgapp/getOrderList", data, (response) => {
          console.log(response.data);
          if (response.status >= 200 && response.status < 300) {
            Toast.clear();
            var data = response.data;
            if (data.msg == "success") {
              var list = data.list;
              this.sumTradeAmount = (data.count.sumTradeAmount / 100).toFixed(2);
              list.forEach((element) => {
                element.realAmount = (element.realAmount / 100).toFixed(2);
                element.tradeAmount = (element.tradeAmount / 100).toFixed(2);
                element.afterBalance = (element.afterBalance / 100).toFixed(2);
                element.refundAmount = (element.refundAmount / 100).toFixed(2);
                if (element.status == 5) {
                  element.statusName = "已退款";
                }
                if (element.status == 4) {
                  element.statusName = "退款处理中";
                }
                if (element.status == 3) {
                  element.statusName = "退款审核中";
                }
                if (element.status == 2) {
                  element.statusName = "人工确认已支付";
                }
                if (element.status == 1) {
                  element.statusName = "已支付";
                }
              });
              if (list.length < this.pageSize) {
                this.flag = false;
              }
              if (this.page == 1) {
                this.list = list;
              } else {
                this.list = this.list.concat(list);
              }
            }
          } else {
            Toast.clear();
            Toast.fail(response.status);
          }
        });
      },
      loadmore() {
        console.log("触底了");
        if (this.flag) {
          this.page++;
          this.getOrderList();
        } else {
          Toast("没有更多内容了~");
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .main {
    background-color: #f7f8fa;
    height: 100vh;
  }
  .select_box {
    width: 100%;
    background-color: #fff;
    text-align: center;
  }
  .record_oli {
    width: 100%;
    height: 100px;
    background-color: #fff;
    border-bottom: 1px solid #f5f6f7;
    display: flex;
    overflow: hidden;
  }
  .record_oli_left {
    width: 80px;
    height: 100%;
    margin: 0 10px;
  }
  .record_oli_left img {
    width: 100%;
    height: 90%;
    margin-top: 5%;
  }
  .record_oli_right {
  }
  .right_title {
    font-size: 16px;
    height: 25px;
    line-height: 25px;
  }
  .right_line {
    display: flex;
    font-size: 12px;
    line-height: 20px;
  }
  .price {
    margin-left: 8px;
  }
  .chooseTime {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: #fff;
    font-size: 12px;
  }
  .choose_box {
    width: 93%;
    margin: auto;
  }
  .choose_left {
    float: left;
  }
  .choose_right {
    float: right;
  }
  .timeChoose {
    width: 300px;
  }
  .none {
      width: 121px;
      height: 100px;
      margin: auto;
      margin-top: 30px;
      text-align: center;
      font-size: 20px;
  }
  .none img {
      width: 95%;
      height: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/cardComeon_record.vue